var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Subject } from '@/models/Subject';
import SelectFilter from '@/components/select-filter/SelectFilter';
import ErrorHandler from '@/support/ErrorHandler';
import { UserSubjectSummary } from '@/models/UserSubjectSummary';
import { UserSubject } from '@/models/UserSubject';
import LoaderCard from '../loader-card/LoaderCard';
import { excludeRoles } from '@/support/ExcludeRoles';
import SubjectDialog from '@/components/SubjectDialog/SubjectDialog.vue';
import { cloneDeep } from 'lodash';
import { RolesEnum } from '@/items/Roles';
let SubjectRow = class SubjectRow extends Vue {
    constructor() {
        super(...arguments);
        this.visible = {
            actions: true,
            userSubjectInfo: false,
        };
        this.newSubject = null;
        this.editing = false;
        this.orginalName = '';
        this.isSelected = false;
        this.selectedSubject = null;
        this.selectedPeriod = {};
        this.selectedSubjectLabels = {};
        this.selectedLevel = {};
        this.isShowingPopup = false;
        this.statuses = [];
        this.isFetchingUserSubjects = false;
        this.subjectDialogSubject = null;
        this.isSubjectDialogOpen = false;
        this.RolesEnum = RolesEnum;
    }
    get dialogOptions() {
        const subject = this.selectedSubject;
        return {
            title: subject.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.subject') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!subject) {
                            return;
                        }
                        subject
                            .delete()
                            .then(() => {
                            this.editing = false;
                            this.$emit('deleted', subject);
                        })
                            .catch((error) => {
                            subject.name = this.orginalName;
                            this.resetTemporaryVars();
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedSubject = null;
                    },
                },
            },
        };
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].curriculum.subject.includes(this.$store.state.Auth.roles[0].id);
    }
    displaySummary() {
        this.isFetchingUserSubjects = true;
    }
    async showSubjectSummary() {
        await this.fetchUserSubjects();
        this.isShowingPopup = true;
    }
    mounted() {
        if (this.subject.subject_labels) {
            this.selectedSubjectLabels.value = this.subject.subject_labels.map((label) => label.id);
        }
        this.initialize();
        if (this.selected) {
            this.isSelected = cloneDeep(this.selected);
        }
    }
    initialize() {
        this.visible = { ...{}, ...this.visible, ...this.visibility };
        if (this.$store.state.selected === null) {
            this.$store.dispatch('selectedChanged', []);
        }
        else {
            // this.setSelected();
        }
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'RESET_CHECKBOXES') {
                this.isSelected = false;
            }
            else if (mutation.type === 'SELECTED_CHANGE') {
                // this.setSelected();
            }
        });
    }
    async fetchUserSubjects() {
        this.isFetchingUserSubjects = true;
        if (!this.subject) {
            return;
        }
        const subject = this.subject;
        if (!subject) {
            return;
        }
        await new UserSubjectSummary()
            .filter({
            subjects: subject.id ? [subject.id] : [],
        })
            .load()
            .then((response) => {
            this.statuses = this.$set(this, 'statuses', new UserSubject().dataToModel({}, 'UserSubject', response.data.data));
            this.isFetchingUserSubjects = false;
        });
    }
    onOpenSubjectDialog(subject) {
        if (!subject || !subject.id) {
            return;
        }
        this.subjectDialogSubject = subject;
        this.isSubjectDialogOpen = true;
    }
    getSubjectStatusCount(subject) {
        const totals = {
            highlighted: 0,
            busy: 0,
            old: 0,
            closed: 0,
            finished: 0,
            future: 0,
        };
        this.statuses.forEach((userSubject, index) => {
            if (userSubject.subject !== subject.id) {
                return;
            }
            if (totals[userSubject.status || ''] !== undefined) {
                totals.inactive -= 1;
                totals[userSubject.status] += 1;
            }
        });
        return totals;
    }
    updateSubject(currentSubject) {
        const payload = {
            name: currentSubject.name,
            subject_labels: this.selectedSubjectLabels.value,
        };
        if (currentSubject.level !== undefined) {
            payload.level = this.selectedLevel.value;
        }
        if (currentSubject.period !== undefined) {
            payload.period = this.selectedPeriod.value;
        }
        currentSubject
            .include(['level', 'period', 'subject_labels'])
            .update(payload)
            .then((updatedSubject) => {
            this.editing = false;
            this.subject.level = updatedSubject.level;
            this.subject.period = updatedSubject.period;
            this.subject.subject_labels = updatedSubject.subject_labels;
            this.resetTemporaryVars();
            this.refreshDataTable();
        })
            .catch((error) => {
            currentSubject.name = this.orginalName;
            this.resetTemporaryVars();
            ErrorHandler.network(error);
        });
    }
    deleteSubject(subject) {
        this.selectedSubject = subject;
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    storeSelectedSubject(subject) {
        this.$emit('change:subject-row', subject);
        this.$store.dispatch('selectedChanged', subject);
    }
    resetTemporaryVars() {
        this.orginalName = '';
        this.selectedLevel = {};
        this.selectedPeriod = {};
        this.selectedSubjectLabels = {};
        if (this.subject.subject_labels)
            this.selectedSubjectLabels.value = this.subject.subject_labels.map((label) => label.id);
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    toggleSelected(value = true) {
        this.$nextTick(() => {
            this.isSelected = value;
        });
    }
    setSelected() {
        this.isSelected = this.$store.state.selected.some((currentSubject) => {
            return currentSubject.id === this.subject.id;
        });
    }
    get user() {
        return this.$store.state.Auth;
    }
    get isTeacherWithExpertRights() {
        return this.user && this.user.isTeacherWithExpertRights();
    }
    disabledChanged(isDisabled) {
        if (isDisabled) {
            this.isSelected = false;
        }
    }
    selectedTopicsClear(topics) {
        if (!topics.length && !this.disabled) {
            this.isSelected = false;
        }
    }
    checkboxChange() {
        let selectedSubjects = this.$store.state.selected;
        const selectedTopics = this.$store.state.selectedTopics;
        if (this.isSelected) {
            if (!selectedSubjects) {
                selectedSubjects = [];
            }
            selectedSubjects.push(this.subject);
            this.$emit('selectedSubject', this.subject);
        }
        else {
            if (selectedSubjects == null) {
                return;
            }
            selectedSubjects = selectedSubjects.filter((subject) => {
                return subject.id !== this.subject.id;
            });
            this.$emit('selectedRemoveSubject', this.subject);
        }
        this.$store.dispatch('selectedChanged', selectedSubjects);
    }
};
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], SubjectRow.prototype, "hasLink", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], SubjectRow.prototype, "disabled", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], SubjectRow.prototype, "selectable", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], SubjectRow.prototype, "selected", void 0);
__decorate([
    Prop({ default: new Subject() }),
    __metadata("design:type", typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object)
], SubjectRow.prototype, "subject", void 0);
__decorate([
    Prop({ default: () => { } }),
    __metadata("design:type", Object)
], SubjectRow.prototype, "visibility", void 0);
__decorate([
    Watch('disabled'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SubjectRow.prototype, "disabledChanged", null);
__decorate([
    Watch('$store.state.selectedTopics', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], SubjectRow.prototype, "selectedTopicsClear", null);
__decorate([
    Watch('isSelected', { immediate: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SubjectRow.prototype, "checkboxChange", null);
SubjectRow = __decorate([
    Component({
        components: {
            SelectFilter,
            LoaderCard,
            SubjectDialog,
        },
    })
], SubjectRow);
export default SubjectRow;
